import React, { useState, useEffect } from 'react';

import Storage from 'src/utils/storage/storage';
import { Skeleton, Stack } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import IconButton from '@mui/material/IconButton';
import StarRateIcon from '@mui/icons-material/StarRate';
import './section.scss';
import { Navigate, useNavigate } from 'react-router';
import { fetchScenarioDetails } from 'src/pages/analytics/simulator/home/api/simulator-module-api';
import { setScenario } from 'src/pages/analytics/simulator/home/store/simulator-home-slice';
import { getAccessConfigForScenario } from 'src/pages/analytics/simulator/home/store/simulator-home-async-thunks';
import { setFavoriteStatusForPages } from 'src/components/layout/appDrawer/app-drawer-slice';
import { useAppDispatch } from '../../../../../../hooks';
import PageListItem from './page-list-item';
import {
  IIdentifierObject,
  IPageListItem
} from '../../../types/landing-api-response.model';
import {
  setActiveBottomTab,
  toggleFavorite
} from '../../../store/landing-slice';

export default function PageListComponent({
  pageList,
  sectionType = 'favorite',
  identifierMap = {}
}: {
  pageList: IPageListItem[];
  sectionType: 'favorite' | 'recently-open';
  identifierMap?: IIdentifierObject;
}) {
  const appDispatch = useAppDispatch();

  const navigate = useNavigate();

  // getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();

  // handler for removing favorite
  const handleToggleFavorite = (item: IPageListItem) => {
    // getting the formatted payload
    const favPayload = {
      // setting identifier as per map object
      identifier: identifierMap[item.identifier],
      identifier_pk_id: item.identifier_pk_id,
      is_favourite: false
    };

    // calling the favorite api for toggling the item as favorite
    appDispatch(toggleFavorite({ ...favPayload, sourceID: sourceId })).then(
      () => {
        // updating pages data on favorite click
        appDispatch(
          setFavoriteStatusForPages({
            pageName: item.identifier_pk_id,
            isFavoriteValue: 0
          })
        );
      }
    );
  };

  // handler for navigating to favorite page
  const handleNavigateToFavorite = (favItem: IPageListItem) => {
    // if route url is present then navigate to that respective PBI page
    if (favItem.route_url) {
      navigate(favItem.route_url);
    }
    // if route url is not present then fetch the scenario details and navigate to the scenario
    else {
      // fetching the scenario details
      fetchScenarioDetails(sourceId, favItem.identifier_pk_id)
        .then((response) => response.data)
        .then((scenario) => {
          appDispatch(setScenario(scenario));
          navigate(`/srm/simulator/${scenario.pk_id}/planner`);
          // reset the activeBottomTab (if any popup is opened on homepage initially)
          appDispatch(setActiveBottomTab(''))
          return appDispatch(
            getAccessConfigForScenario({
              scenarioId: scenario.pk_id,
              sourceId
            })
          );
        });
    }
  };
  return (
    <>
      {pageList.map((ele) => (
        <div className='fav-item-master-div'>
          {sectionType === 'favorite' && (
            <div className='fav-list-icon-div'>
              <IconButton
                aria-label='remove from favorites'
                onClick={() => handleToggleFavorite(ele)}
              >
                <StarRateIcon sx={{ fontSize: '16px', color: '#0000a0' }} />
              </IconButton>
            </div>
          )}
          <PageListItem
            favItem={ele}
            handleNavigateToFavorite={handleNavigateToFavorite}
          />
        </div>
      ))}
    </>
  );
}

PageListComponent.defaultProps = {
  identifierMap: {}
};
